import { Waves, Landmark, Mountain, Car, Sun, Utensils, Baby, Dog, Accessibility, CalendarDays, Home, MapPin, Map, Info } from "lucide-react";

/** Themen der Reisetipps – Schlüssel wie backend/tip_topics.py; Beschriftungen in translations tips.topics. */
export const TIP_TOPICS = ["beaches", "excursions", "activities", "travel", "weather", "food", "family", "pets", "accessible", "season", "accommodation", "places", "island", "practical"];

export const TOPIC_ICONS = { beaches: Waves, excursions: Landmark, activities: Mountain, travel: Car, weather: Sun, food: Utensils, family: Baby, pets: Dog, accessible: Accessibility, season: CalendarDays, accommodation: Home, places: MapPin, island: Map, practical: Info };

export const topicLabel = (t, key) => (key && t.tips.topics?.[key]) || "";
